import { render, staticRenderFns } from "./metrics_score_placeholder.vue?vue&type=template&id=54dcf88b&scoped=true&"
var script = {}
import style0 from "./metrics_score_placeholder.vue?vue&type=style&index=0&id=54dcf88b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dcf88b",
  null
  
)

export default component.exports